module.exports = __webpack_public_path__ + "397951431dab1a7de6ad43a116a25da1.jpg";